import React from 'react';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data,onDelete,onEdit}) => {
    const rows = [
        { label: 'First Name', value: data.firstName },
        { label: 'Last Name', value: data.lastName },
        { label: 'Email', value: data.email, fullWidth: true },
        { label: 'Role', value: data.role },
    ];

    const menuItems = [
        { label: 'Edit', onClick: onEdit },
        { label: 'Delete', onClick: onDelete },
    ];

    return (
        <PPMobileCardView
            title={`${data.firstName} ${data.lastName}`}
            rows={rows}
            menuItems={menuItems}
        />
    );
};

export default Mobile;
